import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../src/styles.css";
import { WaitingRoom } from "../src/waiting-room/WaitingRoom";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Application root is missing");
}

createRoot(root).render(
  <StrictMode>
    <WaitingRoom />
  </StrictMode>,
);
